import React,{useState, useEffect, Children } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import MobileNav from '../Component/MobileNav'; 
// import { Link, useNavigate } from 'react-router-dom';
// import Search from '../Component/Search';
import {Link, useNavigate} from 'react-router-dom';
function Header() {
// addremove class on search
// Hover Dropdown
const [show, setShow] = useState(false);
const [showmore, setShowmore] = useState(false);
const [Showmoresub, setShowmoresub] = useState(false);
const [showexplore, setShowexplore] = useState(false);
const [showone, setShowOne] = useState(false);
const [showtwo, setShowTwo] = useState(false);
const [showthree, setShowThree] = useState(false);
const [showtwoone, setShowTwoOne] = useState(false);
const showDropdown = (e)=>{
setShow(!show);
}
const hideDropdown = e => {
setShow(false);
}
const showDropdownMore = (e)=>{
setShowmore(!showmore);
}
const hideDropdownMore = e => {
setShowmore(false);
}
const showDropdownExplore = (e)=>{
setShowexplore(!showexplore);
}
const hideDropdownExplore = e => {
setShowexplore(false);
}
// showDropdownMoresub
const showDropdownMoresub = (e)=>{
setShowmoresub(!Showmoresub);
}
const hideDropdownMoresub = e => {
setShowmoresub(false);
}
// One
const showDropdownOne = (e)=>{
setShowOne(!showone);
}
const hideDropdownOne = e => {
setShowOne(false);
}
// two
const showDropdownTwo = (e)=>{
setShowTwo(!showtwo);
}
const hideDropdownTwo = e => {
setShowTwo(false);
}
// two one
const showDropdownTwoOne = (e)=>{
setShowTwoOne(!showtwoone);
}
const hideDropdownTwoOne = e => {
setShowTwoOne(false);
}
const showDropdownThree = (e)=>{
setShowThree(!showthree);
}
const hideDropdownThree = e => {
setShowThree(false);
}
// Hover Dropdown
// addremove class on search
const handleFocus = e => {
e.target.classList.add("SerchActive");
e.target.placeholder = "Type Here"
};
const handleBlur = e => {
e.target.classList.remove("SerchActive");
e.target.placeholder = "Search"
};
// addremove class on search
// State Set for form and redirect and transfer state data to another component
const [state, setState] = React.useState('');
const navigate = useNavigate();
const searchGoogle = async (e) => {
e.preventDefault()
// transfert in target value on submit state
navigate("/search-results", { state: state });
// transfert in target value on submit state
console.log(state,"State");
};
// ctmHeader
// document.querySelectorAll('.menu-Bar').forEach(function(menuBar) {
//     menuBar.addEventListener('click', function() {
//       document.querySelectorAll('.menu-Bar').forEach(function(item) {
//         item.classList.toggle('open');
//       });
//       document.querySelectorAll('.menuWrap').forEach(function(menuWrap) {
//         menuWrap.classList.toggle('open');
//       });
//     });
//   });
  
// document.querySelectorAll('.menu-Bar').forEach(function(menuBar) {
//     menuBar.addEventListener('click', function() {
//               document.querySelectorAll('.menu-Bar').forEach(function(item) {
//                 item.classList.toggle('open');
//               });
//             });
// });  


//   $(".menu-Bar").click(function(){
//   $(".menu-Bar").toggleClass("open");
//  $(".menuWrap").toggleClass("open");
// });




// State Set for form and redirect and transfer state data to another component
return (
<>
    <header className="App-header">
        <div className="container-fluid">
            <Navbar expand="lg">
                <div className='logoHumberg'>
                <Navbar.Brand to="/" as={Link}>
                    <img src={process.env.PUBLIC_URL + "/assets/img/header-logo.png"} alt="" className="img-fluid desktop-logo" />
                    <img src={process.env.PUBLIC_URL + "/assets/img/responsive-logo.svg"} alt="" className="img-fluid responsive-logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                </div>
                <div className='header-right'>
                    <div className="header-top">
                       
                        <div className="header-box">
                            <h6>
                                <img src={process.env.PUBLIC_URL + '/assets/img/open-hours-icon.svg'} className='img-fluid' alt="" />
                                Open Hours
                            </h6>
                            <p>Mon to Fri 8:00 AM to 7:30 PM </p>
                            <p>Working Saturday 8:00 AM to 5:00 PM </p>
                        </div>
                        <div className="header-box">
                            <h6>
                                <img src={process.env.PUBLIC_URL + '/assets/img/book-session-icon.svg'} className='img-fluid' alt="" />
                                Book one on one Session
                            </h6>
                            <p>Schedule a meeting by submitting a request form </p>
                            <Link as={Link} to="/book-session" className='btn-dfault'>
                            Book Session
                            </Link>
                        </div>
                        <div className="header-box">
                            <NavDropdown title="Explore Habib University" id="basic-nav-dropdown" show={showexplore} onMouseEnter={showDropdownExplore} onMouseLeave={hideDropdownExplore}>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/">Campus Website</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/admissions/">Admissions</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/academics/">Academics</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/student-affairs/">Students</NavDropdown.Item>
                                <NavDropdown.Item target="_blank" href="https://habib.edu.pk/HU-news/">News</NavDropdown.Item>
                            </NavDropdown>
                        
                        </div>
                    </div>
    <div className="header-bottom">
        <div className="inner-header-btm">
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="main-nav">
                    <li className='nav-item home-item'>
                        <Nav.Link as={Link} to="/"> <img className='img-fluid me-2' src={process.env.PUBLIC_URL + '/assets/img/home-icon.svg'} alt="" />Home</Nav.Link>
                    </li>
                    <li className='nav-item'>
                    <NavDropdown title={<Link to="/about" as={Link}>About</Link>} id="basic-nav-dropdown" show={show} onMouseEnter={showDropdown} onMouseLeave={hideDropdown}>
                            <NavDropdown.Item as={Link} to="/library-hours">Library Hours</NavDropdown.Item>
                            <NavDropdown className='subdropdownNav' title="Patron/User Policies" id="" show={Showmoresub} onMouseEnter={showDropdownMoresub} onMouseLeave={hideDropdownMoresub}>
                                <NavDropdown.Item as={Link} to="/borrowing-policies">Borrowing Policies</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/computer-use-policy">Computer Use Policy</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/discussion-rooms-policy">Discussion Rooms Policy</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/compliance">Compliance</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown.Item as={Link} to="/internship-and-student-employment-opportunities">Internship & Student Employment Opportunities</NavDropdown.Item>
                        </NavDropdown>
                    </li>
                    <li className='nav-item firstDropDown'>
                        <NavDropdown title="Explore" id="basic-nav-dropdown" show={showone}
                            onMouseEnter={showDropdownOne}
                            onMouseLeave={hideDropdownOne}>
                            <NavDropdown.Item as={Link} to="/collaborative-working-and-learning-spaces">Collaborative Working and Learning Spaces</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/computer-and-technology">Computer and Technology (Equipment)</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/printing-scanning-and-photocopying">Printing, Scanning and Photocopying</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/library-services">Library Services</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/maker-space">Maker Space</NavDropdown.Item>
                        </NavDropdown>
                    </li>
                    <li className='nav-item secondDropDown'>
                        <NavDropdown title={<Link to="/find-resources" as={Link}>Find Resources</Link>} id="showtwo" show={showtwo} onMouseEnter={showDropdownTwo} onMouseLeave={hideDropdownTwo}>
                            <NavDropdown.Item target="_blank" href="https://catalog.habib.edu.pk/">Book/Catalog</NavDropdown.Item>
                            <NavDropdown.Item target="_blank" href="https://hira.habib.edu.pk/jspui/">HIRA (Habib Institutional Repository & Archive)</NavDropdown.Item>
                            <NavDropdown.Item target="_blank" href="https://habib.edu.pk/pakistanhistorybibliography/">Pakistan History Bibliography</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/eresources-databases">E-Resources & Databases</NavDropdown.Item>
                           
                            <NavDropdown.Item as={Link} to="/free-open-access-resources">Free/Open Access Resource </NavDropdown.Item>
                            <NavDropdown.Item target="_blank" href="https://libbyapp.com/library/habibuni">Audio Books</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/newspaper-magazine">Newspaper and Magazines </NavDropdown.Item>
                        </NavDropdown>
                    </li>
                    <li className='nav-item'>
                        <NavDropdown title={<Link to="/research-support" as={Link}>Research Support</Link>} id="basic-nav-dropdown" show={showthree}
                            onMouseEnter={showDropdownThree}
                            onMouseLeave={hideDropdownThree}>
                            <NavDropdown.Item as={Link} to="/book-session">Book ‘One on one’ session</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/event-calendar">Upcoming Trainings/Workshops</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/self-learning-resources">Self-Learning Resources</NavDropdown.Item>
                        </NavDropdown>
                    </li>
                    <li className='nav-item'>
                        <Nav.Link as={Link} to="/resource-request">Resource Request</Nav.Link>
                    </li>
                    <li className='nav-item'>
                        <Nav.Link as={Link} to="/frequently-asked-questions">FAQ's</Nav.Link>
                    </li>
                    <li className='nav-item'>
                        <Nav.Link as={Link} to="/aska-librarian">Contact</Nav.Link>
                    </li>
                </Nav>
                <div className="rispon-menu-bottom">
                    <div className="header-box">
                        <h6>
                            <img src='/assets/img/book-session-icon.svg' className='img-fluid' alt="" />
                            Book one on one Session
                        </h6>
                        <p>Schedule a meeting by submitting a request form </p>
                        <Link as={Link} to="/book-session" className='btn-dfault'>
                        Book Session
                        </Link>
                    </div>
                   
                </div>
            </Navbar.Collapse>
            <Form className="search-bar-header" onSubmit={searchGoogle}>
                <InputGroup>
                    <Button variant="" id="search-nav">
                        <img src={process.env.PUBLIC_URL +'/assets/img/search-icon.svg'} alt="" />
                    </Button>
                    <Form.Control placeholder="Search" aria-label="Search" aria-describedby="search-nav" onFocus={handleFocus} onBlur={handleBlur} onChange={(e)=> setState(e.target.value)}
                        value={state}
                        />
                </InputGroup>
            </Form>
        </div>
    </div>
                </div>
            </Navbar>
        </div>
        <MobileNav />
        
    </header>
</>

);
}
export default Header;